<template>
  <footer>
    <div class="navigationBox">
      <div :class="standing == 0 ? 'widthTwo box' : 'widthOne box'">
        <div class="singleNavBox" @click="selectedEvent(0)">
          <img
            v-if="selected != 0"
            class="singleImage"
            src="@/assets/images/button-one.svg"
          />
          <img
            v-if="selected == 0"
            class="singleImage"
            src="@/assets/images/button-oneSelected.svg"
          />
          <div :class="selected == 0 ? 'navText selected' : 'navText'">生日榜</div>
        </div>
        <div class="singleNavBox" @click="selectedEvent(1)">
          <img
            v-if="selected != 1"
            class="singleImage"
            src="@/assets/images/button-two.svg"
          />
          <img
            v-if="selected == 1"
            class="singleImage"
            src="@/assets/images/button-twoSelected.svg"
          />
          <div :class="selected == 1 ? 'navText selected' : 'navText'">入职榜</div>
        </div>
        <div class="singleNavBox" @click="selectedEvent(2)">
          <img
            v-if="selected != 2"
            class="singleImage"
            src="@/assets/images/button-three.svg"
          />
          <img
            v-if="selected == 2"
            class="singleImage"
            src="@/assets/images/button-threeSelected.svg"
          />
          <div :class="selected == 2 ? 'navText selected' : 'navText'">我的</div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { reactive, toRefs, computed, onMounted, ref, watchEffect } from "vue";
import router from "@/router";
import { useStore } from "vuex";
const store = useStore();

const props = defineProps({
  index: "index",
});

// const store = useStore();
const state = reactive({
  selected: 0,
  // 是否登录、是否有学校(0\1)
  standing: 0,
  currentBottomBtn: computed(() =>  store.state.allData.currentBottomBtn),
});
const { currentBottomBtn, selected, standing } = toRefs(state);
// state.selected = props.index;
// console.log( props.index);

watchEffect(() => {
  switch (state.currentBottomBtn) {
    case 0:
      state.selected = 0;
      break;
    case 1:
      state.selected = 1;
      break;
    case 2:
      state.selected = 2;
      break;
  }
});

const selectedEvent = (index) => {
  switch (index) {
    case 0:
      state.selected = 0;
      router.push({ path: "/Home" });
      store.commit("CURRENTBOTTOMBTN", 0);
      break;
    case 1:
      state.selected = 1;
      router.push({ path: "/entry" });
      store.commit("CURRENTBOTTOMBTN", 1);
      break;
    case 2:
      state.selected = 2;
      router.push({ path: "/my" });
      store.commit("CURRENTBOTTOMBTN", 2);
      break;
  }
};
</script>

<style lang="less" scoped>
@import "@/styles/style.less";
.navigationBox {
  .wh(750, 98);
  // width: 7.5rem;
  position: fixed;
  bottom: 0;
  z-index: 999;
  padding-bottom: 0.15rem;
  background-color: #fff;
  // padding-bottom: constant(safe-area-inset-bottom); /*兼容 IOS<11.2*/
  // padding-bottom: env(safe-area-inset-bottom); /*兼容 IOS>11.2*/
  // background-color: #ff0;
  // background-color:@c;
  // box-shadow: 0 * 0.01rem -6 * 0.01rem 21.1 * 0.01rem 0 * 0.01rem rgba(34, 34, 34, 0.04);
  .widthOne {
    .wh(564, 80);
    margin-left: 93 * 0.01rem;
  }
  .widthTwo {
    .wh(588, 80);
    margin-left: 81 * 0.01rem;
  }
  .box {
    margin-top: 9 * 0.01rem;
    display: flex;
    justify-content: space-between;
    .singleNavBox {
      cursor: pointer;
      .wh(48, 80);
      position: relative;
      // background-color: #0ff;
      .singleImage {
        .wh(48, 48);
        position: absolute;
        left: 0rem;
        top: 0rem;
        // .pos($top: 0, $left: 0);
      }
      .navText {
        // .pos($bottom: 0, $left: 4);
        position: absolute;
        left: -0.048rem;
        bottom: 0rem;
        .wh(60, 30);
        .fcs(#333, 20, center);
      }
      .selected {
        .fcs(#6197ff, 20, center);
      }
    }
  }
}
</style>
